import { useLocation, useNavigate } from "react-router-dom";
import InfoRow from "../../components/InfoRow";
import UNAUTHORIZED from "../UNAUTHORIZED";
import ActionButtonsEdit from "./ActionButtonsEdit";
import ActionButtonsNew from "./ActionButtonsNew";
import { FiUser, FiArrowLeft } from "react-icons/fi";

export default function StudentAud() {
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;
  const pathname = useLocation().pathname.split("/")[3];
  const location = useLocation();
  const navigate = useNavigate();

  const element = location.state;

  return (
    <div className="min-h-screen px-4 sm:px-8 py-6">
      {!["admin", "auditor", "agent"].includes(user) ? (        <UNAUTHORIZED />
      ) : (
        <div className="max-w-3xl mx-auto space-y-6">

          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center">
                <FiUser size={22} className="text-indigo-400" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-white">Student Information</h1>
                <p className="text-slate-400 text-sm">Auditing detail view</p>
              </div>
            </div>
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 text-slate-300 hover:text-white px-4 py-2 rounded-lg transition-all"
            >
              <FiArrowLeft size={14} /> Back
            </button>
          </div>

          {/* Student Info Card */}
          <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 space-y-1">
            <h2 className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-4">Personal Details</h2>
            <InfoRow data={element.full_name} label={"Student Name"} about="full_name" />
            <InfoRow data={element.middle1_name} label={"Father Name"} about="middle1_name" />
            <InfoRow data={element.passport_number} label={"National ID or Passport Number"} about="passport_number" />
            <InfoRow data={element.phone} label={"Phone Number"} about="phone" />
            <InfoRow data={element.email} label={"Email"} about="email" />
            <InfoRow data={element.exam_type} label={"Exam Type"} about="exam_type" />
            <InfoRow data={element.date_of_birth} label={"Date of Birth"} about="date_of_birth" />
            <InfoRow data={element.gender} label={"Gender"} about="gender" />
            <InfoRow data={element.address} label={"Address"} about="address" />
            <InfoRow data={element.postal_code} label={"Postal Code"} about="postal_code" />
            <InfoRow data={element.test_center_name} label={"Test Center Name"} about="test_center_name" />
          </div>

          {/* Universities Card (from student_colleges) */}
          {(element.collegeName1 || element.collegeName2 || element.collegeName3 || element.collegeName4 || element.collegeName5) && (
            <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 space-y-1">
              <h2 className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-4">Universities</h2>
              {element.collegeName1 && <InfoRow data={element.collegeName1} label={"University 1"} about="collegeName1" />}
              {element.collegeName2 && <InfoRow data={element.collegeName2} label={"University 2"} about="collegeName2" />}
              {element.collegeName3 && <InfoRow data={element.collegeName3} label={"University 3"} about="collegeName3" />}
              {element.collegeName4 && <InfoRow data={element.collegeName4} label={"University 4"} about="collegeName4" />}
              {element.collegeName5 && <InfoRow data={element.collegeName5} label={"University 5"} about="collegeName5" />}
            </div>
          )}

          {/* Specializations Card (from student_specializations) */}
          {(element.specialization1 || element.specialization2 || element.specialization3) && (
            <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 space-y-1">
              <h2 className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-4">Specializations</h2>
              {element.specialization1 && <InfoRow data={element.specialization1} label={"Specialization 1"} about="specialization1" />}
              {element.specialization2 && <InfoRow data={element.specialization2} label={"Specialization 2"} about="specialization2" />}
              {element.specialization3 && <InfoRow data={element.specialization3} label={"Specialization 3"} about="specialization3" />}
            </div>
          )}

          {/* ACT 1 Card */}
          <div className="rounded-2xl bg-indigo-600/5 border border-indigo-500/20 backdrop-blur-sm p-6 space-y-1">
            <h2 className="text-indigo-400 text-xs font-semibold uppercase tracking-widest mb-4">ACT 1 Results</h2>
            <InfoRow data={element.act1_id} label={"ACT 1 ID"} about="act1_id" />
            <InfoRow data={element.exam_name} label={"Exam Name"} about="exam_name" />

            {Array.isArray(element.act1_scores) && element.act1_scores.length > 0 ? (
              (() => {
                const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];
                const grouped = new Map();
                element.act1_scores.forEach((item) => {
                  const tno = item.trial_no;
                  if (!grouped.has(tno)) {
                    grouped.set(tno, {
                      trial_no: tno,
                      trial_date: item.trial_date,
                      total_score: item.total_score,
                      subjects: []
                    });
                  }
                  grouped.get(tno).subjects.push({
                    subject_name: item.subject_name,
                    subject_score: item.subject_score,
                  });
                });
                grouped.forEach((trial) => {
                  trial.subjects.sort((a, b) => {
                    const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
                    const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
                    return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
                  });
                });
                return Array.from(grouped.values()).map((scoreTrial, index) => (
                  <div key={scoreTrial.trial_no || index} className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                    <h4 className="text-indigo-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">
                      Trial {scoreTrial.trial_no}
                    </h4>
                    <InfoRow data={scoreTrial.total_score} label={"Total Score"} about={`act1_total_score_${scoreTrial.trial_no}`} />
                    <InfoRow data={scoreTrial.trial_date} label={"Trial Date"} about={`act1_trial_date_${scoreTrial.trial_no}`} />
                    {Array.isArray(scoreTrial.subjects) && scoreTrial.subjects.length > 0 && (
                      <div className="mt-2 pl-3 border-l-2 border-indigo-500/30 space-y-1">
                        {scoreTrial.subjects.map((subject, subIndex) => (
                          <InfoRow
                            key={subIndex}
                            data={subject.subject_score}
                            label={subject.subject_name}
                            about={`act1_subject_${String(subject.subject_name).toLowerCase()}_${scoreTrial.trial_no}`}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                ));
              })()
            ) : (
              <p className="text-slate-500 text-sm py-2">No trial scores found for ACT 1.</p>
            )}

            <div className="pt-3 border-t border-white/10 mt-3 space-y-1">
              <InfoRow data={element.act1_copy_number} label={"Copies Number"} about="act1_copy_number" />
            </div>
          </div>

          {/* SSC Trials Card */}
          {element.act1 && (
            <div className="rounded-2xl bg-amber-600/5 border border-amber-500/20 backdrop-blur-sm p-6 space-y-1">
              <h2 className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-4">SSC Trials</h2>
              {[1, 2, 3, 4, 5].map(i => {
                const tryDate = element[`act1_try_date${i}`] || element[`ssc_try_date${i}`];
                const tryId = element[`act1_try${i}_id`] || element[`ssc_try${i}_id`];
                if (!tryDate && !tryId) return null;
                return (
                  <div key={i} className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                    <h4 className="text-amber-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">
                      Trial {i}
                    </h4>
                    <InfoRow data={tryDate} label={"Trial Date"} about={`ssc_try_date_${i}`} />
                    <InfoRow data={tryId} label={"Trial ID"} about={`ssc_try_id_${i}`} />
                  </div>
                );
              })}
            </div>
          )}

          {/* ACT 2 Card */}
          {element.act2_id && (
            <div className="rounded-2xl bg-emerald-600/5 border border-emerald-500/20 backdrop-blur-sm p-6 space-y-1">
              <h2 className="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-4">ACT 2 (Subject) Results</h2>
              <InfoRow data={element.act2_id} label={"ACT 2 ID"} about="act2_id" />

              {Array.isArray(element.act2_trials) && element.act2_trials.length > 0 ? (
                element.act2_trials
                  .slice()
                  .sort((a, b) => a.trial_no - b.trial_no)
                  .map((trial, index) => (
                    <div key={trial.trial_no || index} className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                      <h4 className="text-emerald-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">
                        Trial {trial.trial_no}
                      </h4>
                      <InfoRow data={trial.score} label={"Score"} about={`act2_score_${trial.trial_no}`} />
                      <InfoRow data={trial.try_date} label={"Trial Date"} about={`act2_try_date_${trial.trial_no}`} />
                      <InfoRow data={trial.subject} label={"Subject"} about={`act2_subject_${trial.trial_no}`} />
                    </div>
                  ))
              ) : (
                <>
                  {(element.act2_score1 || element.act2_try_date1 || element.subject1) && (
                    <div className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                      <h4 className="text-emerald-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">Trial 1</h4>
                      <InfoRow data={element.act2_score1} label={"Score"} about="act2_score1" />
                      <InfoRow data={element.act2_try_date1} label={"Trial Date"} about="act2_try_date1" />
                      <InfoRow data={element.subject1} label={"Subject"} about="subject1" />
                    </div>
                  )}
                  {(element.act2_score2 || element.act2_try_date2 || element.subject2) && (
                    <div className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                      <h4 className="text-emerald-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">Trial 2</h4>
                      <InfoRow data={element.act2_score2} label={"Score"} about="act2_score2" />
                      <InfoRow data={element.act2_try_date2} label={"Trial Date"} about="act2_try_date2" />
                      <InfoRow data={element.subject2} label={"Subject"} about="subject2" />
                    </div>
                  )}
                  {(element.act2_score3 || element.act2_try_date3 || element.subject3) && (
                    <div className="rounded-xl bg-white/5 border border-white/10 p-4 mt-3">
                      <h4 className="text-emerald-300 font-semibold text-sm mb-3 border-b border-white/10 pb-2">Trial 3</h4>
                      <InfoRow data={element.act2_score3} label={"Score"} about="act2_score3" />
                      <InfoRow data={element.act2_try_date3} label={"Trial Date"} about="act2_try_date3" />
                      <InfoRow data={element.subject3} label={"Subject"} about="subject3" />
                    </div>
                  )}
                  {!element.act2_score1 && !element.act2_try_date1 && !element.subject1 && (
                    <p className="text-slate-500 text-sm py-2">No trial data found for ACT 2.</p>
                  )}
                </>
              )}

              <div className="pt-3 border-t border-white/10 mt-3 space-y-1">
                <InfoRow data={element.act2_copy_number} label={"Copies Number"} about="act2_copy_number" />
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex justify-center gap-4 pb-8">
            {pathname === "new" && <ActionButtonsNew />}
            {pathname === "request_edit" && <ActionButtonsEdit />}
          </div>

        </div>
      )}
    </div>
  );
}
